import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutlined";
import { Box, Button, Typography } from "@mui/material";
import { type FC } from "react";

import * as Styled from "./SignUpSuccess.styles";

interface ISignUpSuccessProps {
  onClose: () => void;
}

export const SignUpSuccess: FC<ISignUpSuccessProps> = ({ onClose }) => {
  return (
    <Styled.Root>
      <CheckCircleOutlineIcon fontSize="large" />
      <Box>
        <Typography variant="body1" sx={{
          fontWeight: 700
        }}>
          Thanks for signing up!
        </Typography>
        <Typography variant="caption" color="gray">
          You’ll be the first to hear about new features, updates, and special
          announcements.
        </Typography>
      </Box>
      <Button
        variant="contained"
        size="large"
        onClick={onClose}
        color="secondary"
        fullWidth
      >
        <Typography sx={{
          textTransform: "none"
        }}>Close</Typography>
      </Button>
    </Styled.Root>
  );
};
